import { render, staticRenderFns } from "./classroom.vue?vue&type=template&id=7289a3c3&scoped=true&"
import script from "./classroom.vue?vue&type=script&lang=js&"
export * from "./classroom.vue?vue&type=script&lang=js&"
import style0 from "./classroom.vue?vue&type=style&index=0&id=7289a3c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7289a3c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
